import React, { Suspense } from 'react';
import Wrapper from './AdminLTE/Wrapper';
import { useOutlet } from 'react-router-dom';
import PageLoader from '../Components/Shared/PageLoader';

export default function Authenticated() {
    const outlet = useOutlet();
    return (
        <Wrapper page_content={
            <Suspense fallback={<PageLoader />}>
                {outlet}
            </Suspense>
        } />
    );
}
